// extracted by mini-css-extract-plugin
export default {"overlay":"ResponsiveLoader_overlay__uWPOf","loader":"ResponsiveLoader_loader__C5Mga","message":"ResponsiveLoader_message__mzDuG"};